const isPlaying = (video: HTMLVideoElement) =>
  video.currentTime > 0 &&
  !video.paused &&
  !video.ended &&
  video.readyState > video.HAVE_CURRENT_DATA

export { isPlaying }
